import type { LaneDetailsDto } from '@uturn/api/v1';
import { createContext } from 'react';

export const LaneDetailContext = createContext<LaneDetailsDto | null>(null);
